import React, { useRef } from 'react'
import UserSidebar from './UserSidebar';
import { useDispatch, useSelector } from 'react-redux';
import Logo from 'assets/images/logo.png';
import useClickOutside from 'utils/clickOutside';
import { toggleSidebar } from 'redux/reducers/sidebarReducer';
import SellerSidebar from './SellerSidebar';

const Sidebar = () => {
    const sidebarRef = useRef();
    const dispatch = useDispatch();
    const { showSidebar } = useSelector(state => state.sidebar);

    useClickOutside(sidebarRef , () => dispatch(toggleSidebar(false)))

    return (
        <div
        ref={sidebarRef} 
        className={`fixed top-0 md:left-0 duration-300 ease-in-out md:z-[1] z-50 bg-white h-screen md:border-none border-r md:bg-transparent  px-4 md:shadow-none shadow-lg
        ${showSidebar ? 'left-0' : '-left-[100%]' } 
        `}>
            <div className='py-4 md:hidden block sm:w-[130px] w-[110px]'>
                <img src={Logo} alt="" />
            </div>
            
            <div className='md:pt-24 pt-10'>
                {/* <UserSidebar /> */}
                <SellerSidebar />
            </div>
        </div>
    )
}

export default Sidebar